<template>
    <main>
        <div class="card-header bg-light border-bottom-0">
            <div class="row align-items-center w-100">
          <div class="col-6 font-weight-bold text-gray-600 h6 mb-0">
            <i class="fas fa-heartbeat text-muted mr-2"></i> Apgar 
          </div>
          <div class="col-6 d-flex justify-content-end">
            <router-link v-if="_can('card.apgar')"
              :to="{ name: 'usuario.apgar', params: { id: idUsuario } }"
              class="btn btn-primary btn-xs btn-icon"
            >
               <i class="fas fa-plus fa-fw"></i>
            </router-link>
          </div>
        </div>
        </div>
        <div class="card-body">
            <div class="d-flex flex-column mb-3">
                <div class="d-flex justify-content-between align-items-center mb-2">
                    <span class="text-muted small font-weight-bold">Última Valoración</span>
                    <span v-if="Object.keys(apgar).length" class="text-bold font-weight-bold">{{apgar.fecha | formatDate }}</span>
                    <span v-else class="badge badge-light text-danger font-italic small">Sin datos...</span>
                </div>
                <div class="d-flex justify-content-between align-items-center mb-2">
                    <span class="text-muted small font-weight-bold">Puntaje Total</span>
                    <span v-if="Object.keys(apgar).length" class="text-bold font-weight-bold">{{apgar.puntaje_total}}</span>
                    <span v-else class="badge badge-light text-danger font-italic small">Sin datos...</span>
                </div>
                <div class="d-flex justify-content-between align-items-center" v-if="Object.keys(apgar).length">
                    <span class="text-muted small font-weight-bold">Interpretación</span>
                    <span :class="[clasificacion_apgar.class, 'px-2 py-1 small rounded']">{{clasificacion_apgar.valoracion}}</span>
                </div>
            </div>
            
            <router-link
              :to="{ name: 'usuario.apgar.historial', params: { id: idUsuario } }"
              class="btn btn-light btn-sm btn-block text-primary font-weight-bold mt-2"
            >
              Ver Historial  <i class="fas fa-history ml-1"></i>
            </router-link>
        </div>
    </main>
</template>
<script>

import valoracionApgarFamiliarService from '../../../../services/valoracionApgarFamiliarService';
import {isEmpty} from 'lodash';
import dayjs from 'dayjs';

export default {
    props: ['idUsuario', 'usuario'],
    data(){
        return {
            apgar:{},
        }
    },
    watch: {
        idUsuario : async function(){
            const response = await valoracionApgarFamiliarService.showLast(this.idUsuario);
            this.apgar= response.data;
        }
    },
    computed: {
        edad : function(){
            if(isEmpty(this.usuario)) return 0;
            return dayjs().diff(this.usuario.fecha_nacimiento, 'year');
        },
        clasificacion_apgar(){
            
            const clasficicacion_ninos = [
                {
                    inicio : 7,
                    fin : 10,
                    valoracion : 'Funcionalidad Normal',
                    class : 'badge badge-success-soft'
                },
                {
                    inicio : 4,
                    fin : 6,
                    valoracion : 'Disfunción Moderada',
                    class : 'badge badge-warning-soft'
                },
                {
                    inicio : 0,
                    fin : 3,
                    valoracion : 'Disfunción Grave',
                    class : 'badge badge-danger-soft'
                }
            ];

            if(this.edad <= 18){
                const clasificacion = clasficicacion_ninos.find(x => this.apgar.puntaje_total >= x.inicio && this.apgar.puntaje_total <= x.fin);
                if(clasificacion) return clasificacion 
            }

            return {
                inicio : 0,
                fin : 0,
                valoracion : 'Cargando clasificacion',
                class : 'span span-default text-danger'
            };
        },
        tiempo_ultimo_apgar (){
            if(isEmpty(this.apgar)) return 0;
            return dayjs().diff(this.apgar.fecha, 'year');
        }
        
    }
}
</script>